import { Typography } from "@p0security/ui";
import { Link } from "react-router-dom";

import { azureAppInstaller } from "./install/azure-app";
import { azureBastionHostInstaller } from "./install/bastion-host";
import { azureIamAssessmentInstaller } from "./install/iam-assessment";
import { azureIamWriteInstaller } from "./install/iam-write";
import { azureJumpHostInstaller } from "./install/jump-host";
import type { AzureInstaller } from "./install/types";

export const azureInstaller: AzureInstaller = {
  components: {
    root: {
      items: {},
    },
    "iam-write": azureIamWriteInstaller,
    "iam-assessment": azureIamAssessmentInstaller,
    "azure-app": azureAppInstaller,
    "jump-host": azureJumpHostInstaller,
    "bastion-host": azureBastionHostInstaller,
  },
  preamble: (
    <>
      <Typography.Text strong>
        Recommended components by use case:
      </Typography.Text>
      <ul className="preamble-list">
        <li>
          <strong>Just-in-time access:</strong>{" "}
          <Link to="./azure-app">App Registration</Link> and{" "}
          <Link to="./iam-write">IAM Management</Link>
        </li>
        <li>
          <strong>SSH via Bastion:</strong>{" "}
          <Link to="./bastion-host">Bastion Host</Link>
        </li>
        <li>
          <strong>Jump host session management:</strong>{" "}
          <Link to="./jump-host">Jump Host Management</Link>
        </li>
      </ul>
    </>
  ),
};
